export default __webpack_public_path__ + "static/media/billing-blue.4a49d2a2.svg";